import {Directive, effect, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {MapRoleService} from '../acl/map-role.service';
import {MapService} from '../api/services/map.service';
import {UserService} from '../api/services/user.service';
import {GraphMap} from '../api/interfaces/graph-node.interface';
import {Permission} from '../acl/map-user-roles.enum';

@Directive({
  selector: '[hasMapPermission]',
  standalone: true
})
export class HasMapPermissionDirective {
  private permission: Permission = 'view';
  private currentMap: GraphMap | undefined;
  private hasView = false;

  constructor(
    private mapRoleService: MapRoleService,
    private mapService: MapService,
    private userService: UserService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    effect(() => {
      // Read signal values — these are stable references, no localStorage parsing
      const changedMap = this.mapService.selectedMap();
      const user = this.userService.user();
      this.currentMap = changedMap;
      if (changedMap) {
        this.updateView(changedMap);
      }
    });
  }

  @Input('hasMapPermission') set permissionInput(permission: Permission) {
    this.permission = permission;
    this.updateView(this.currentMap);
  }

  private updateView(map: GraphMap | undefined) {
    if (!map || !map.id) {
      if (this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
      return;
    }

    // Pass map directly — avoids calling getCurrentSelectedMapFromStore() which
    // parses localStorage, reads route params, and can write to the selectedMap signal
    const hasPermission = this.mapRoleService.hasCurrentUserPermission(this.permission, map);
    if (hasPermission && !this.hasView) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasPermission && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
